//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PDPCommentStatusTag',
  props: {
    approved: {
      type: Boolean, // undefined === unapproved/pending moderation, false = denied
    },
    resolved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approvalStatus: this.approved,
      resolvedStatus: this.resolved,
      open: !this.resolved
        || !this.approved
        || typeof this.approved === 'undefined'
        || this.approved === null,
    };
  },
  computed: {
    hasApprovalStatus() {
      if (typeof this.approved === 'undefined' || this.approved === null) {
        return 'unapproved';
      }

      if (!this.approved) {
        return 'denied';
      }

      return '';
    },
    approvalText() {
      if (typeof this.approved === 'undefined' || this.approved === null) {
        return 'Pending Moderation';
      }

      if (!this.approved) {
        return 'Denied';
      }

      return '';
    },
  },
  watch: {
    resolved(newVal) {
      if (this.hasApprovalStatus) return;

      this.open = !newVal;
    },
    approved(newVal) {
      if (!this.resolved) return;

      this.open = !newVal || typeof newVal === 'undefined' || newVal === null;
    },
  },
};
